module.exports = __webpack_public_path__ + "static/images/p2.39bd0dd.png";